export const ARCHIVE_JOB_REQUEST = 'ARCHIVE_JOB_REQUEST';
export const ARCHIVE_JOB_RESPONSE = 'ARCHIVE_JOB_RESPONSE';
export const ARCHIVE_JOB_RESET = 'ARCHIVE_JOB_RESET';
